module.exports = __webpack_public_path__ + "img/deal-two.e91b6c73.jpg";